import { Controller } from "@hotwired/stimulus";

export default class DecimalLimitController extends Controller {
  static values = { decimals: Number };

  limit(event) {
    const regex = new RegExp(String.raw`^\d*(\.\d{0,${this.decimalsValue}})?$`);
    if (!regex.test(event.target.value)) {
      event.target.value = event.target.value.slice(0, -1);
    }
  }
}
